// The hidden reseller code pages: one per (reseller, product) list, because
// each list has its own code shape (Fender's Punctuate codes are
// XXXX-XXXXX-XXXXX hex; the Obliterate list differs). All lists live in the
// backend's reseller_codes table; the page only decides the input mask, the
// wording, and which product it expects the code to unlock. Not in the
// sidebar — the reseller's own instructions carry the link. To add a list:
// one entry here (and the import, see notepad.md).
export interface ResellerPage {
  readonly path: string
  readonly reseller: string       // lib/api/reseller_codes.ts Reseller enum value
  readonly resellerName: string
  readonly skuName: string        // the sku the list's codes unlock (as named in the store)
  readonly segments: readonly number[]   // the code's dashed segment lengths
}

export const RESELLER_PAGES: readonly ResellerPage[] = [
  { path: "/punctuate-for-fender", reseller: "fender", resellerName: "Fender", skuName: "Punctuate", segments: [4, 5, 5] },
]
